<template>
    <div id="companyLogo">
        <div class="company-logo">
            <table>
                <tr>
                    <td v-for="(img, index) in listArrRow1" :key="index">
                        <div class="prov-box">
                            <div class="pic-box">
                                <img v-lazy="img.path">
                            </div>
                            <div class="prov-name">{{img.name}}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td v-for="(img, index) in listArrRow2" :key="index">
                        <div class="prov-box">
                            <div class="pic-box">
                                <img v-lazy="img.path">
                            </div>
                            <div class="prov-name">{{img.name}}</div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
export default {
  name: 'companyLogo',
  data() {
    return {
      listArrRow1: [
        {
          path: require('@/assets/img/company-logo/dianzi.jpg'),
          name: '中国电子信息产业集团有限公司'
        },
        {
          path: require('@/assets/img/company-logo/zhongruan.jpg'),
          name: '中国软件与技术服务股份有限公司'
        },
        {
          path: require('@/assets/img/company-logo/huidian.jpg'),
          name: '北京慧点科技有限公司'
        },
        {
          path: require('@/assets/img/company-logo/jiaokong.jpg'),
          name: '交控科技股份有限公司'
        }
      ],
      listArrRow2: [
        {
          path: require('@/assets/img/company-logo/beiming.jpg'),
          name: '北明软件有限公司'
        },
        {
          path: require('@/assets/img/company-logo/huachengfeng.jpg'),
          name: '深圳市华成峰科技有限公司'
        },
        {
          path: require('@/assets/img/company-logo/donghua.jpg'),
          name: '东华软件股份公司'
        },
        {
          path: require('@/assets/img/company-logo/zhongke.jpg'),
          name: '北京中科金财科技股份有限公司'
        }
      ]
    };
  }
};
</script>
<style sxoped lang="less">
#companyLogo {
  .company-logo {
    height: 263px;
    width: 1193px;
    margin-left: 97px;
  }
  .company-logo table,
  .company-logo table tr th,
  .company-logo table tr td {
    border: 1px solid #ddd;
  }

  .company-logo table {
    width: 1193px;
    text-align: center;
    border-collapse: collapse;
  }

  .company-logo td {
    height: 131px;
    width: 296px;
    position: relative;
  }
  .prov-box {
    height: 131px;
    width: 298px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0px;
    top: 0px;
    transition: left, top, width, height, 0.2s;
  }
  .pic-box {
    height: 92px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .company-logo td {
    position: relative;
  }
  .prov-box:hover {
    left: -5px;
    top: -5px;
    height: 141px;
    width: 308px;
    box-shadow: 0px 0px 10px #898989;
    background-color: #fff;
  }
}
</style>
